var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detalhe"},[_c('i',{staticClass:"fa-solid fa-magnifying-glass"})])
}]

export { render, staticRenderFns }